import { call } from 'redux-saga/effects'
import createDocument from 'helpers/databases/createDocument'

const createTypeIndex = db =>
  // cloudant will let us know if index already exists,
  // no reason to check beforehand
  createDocument(
    db,
    {
      index: {
        fields: [ 'type', '_id' ]
      },
      name: 'type-index'
    },
    '_index'
  )

function * ensureAppIntegrity(db) {
  yield call(createTypeIndex, db)
}

export default ensureAppIntegrity



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/ensureAppIntegrity/index.js